import { Grid, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import useCheckoutStore from "../../../stores/public/useCheckoutStore";
import show from "../../../api/public/storePages/show";
import showOrder from "../../../api/public/storePages/orders/show";
import { useParams } from "react-router-dom";
import WushCard from "../../../components/layout/WushCard";

export default function OrderConfirmation() {
  const [ storePageError, setStorePageError ] = useState(null);
  const [ order, setOrder ] = useState(null);

  const { reset, storePage, setStorePage } = useCheckoutStore();

  const { id, order_id } = useParams();

  useEffect(() => {
    reset();
    show(id, (response) => {
      console.log(response);
      setStorePage(response);
    }, () => {
      setStorePageError(true);
    });
  }, []);

  useEffect(() => {
    showOrder(id, order_id, (response) => {
      console.log(response);
      setOrder(response);
    });
  }, []);

  if(storePageError || !storePage) {
    return <Stack textAlign="center">
      <Typography variant="h4">
        Store Page Not Found
      </Typography>
    </Stack>;
  }

  console.log(order);

  return (
    <Stack>
      <Stack minHeight="100vh" bgcolor={storePage.background_color}>
        <Grid container px="20%" py={5} spacing={2}>
          <Grid item sm={12}>
            <WushCard
              bgcolor={"#ffffff"}
            >
              <Stack p={2}>
                <Typography variant="h4">
                  Order Confirmation
                </Typography>
              </Stack>
            </WushCard>
          </Grid>
        </Grid>
      </Stack>
    </Stack>
  );
}